import '../styles/page.css'

const Profile = ({ images, key_id, object }) => {
    const imagePath = images(`./${key_id}.jpg`);
    return (
        <div className={`profile-container ${key_id % 2 == 1 ? "right" : ""}`}>
            <img src={imagePath}/>
            <div className="profile-container-info">
                <h2> {object.title} </h2>
                <span> {object.descr} </span>
                <br /> <span> {object.additional}</span>
            </div> 
        </div>
    )
}

export default Profile;